/**
 * SG Entity Change History UI (리스트 배지, 상세 배너, Officer sync, 필드 인디케이터).
 * - VITE_ENTITY_CHANGE_HISTORY=false → off (긴급 롤백용)
 * - 그 외(local/dev/production) → ON for all users
 */
export function isEntityChangeHistoryEnabled(): boolean {
    const v = String(import.meta.env.VITE_ENTITY_CHANGE_HISTORY ?? '').trim().toLowerCase();
    if (v === 'false' || v === '0') return false;
    return true;
}
